import { Actions, createEffect, ofType } from '@ngrx/effects';
import saveCalculationActions from './save-contact.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Injectable } from '@angular/core';
import AppError from 'src/app/model/app-error';

@Injectable()
export class SaveContactEffects {
  start$ = createEffect(() =>
    this.actions$.pipe(
      ofType(saveCalculationActions.start),
      switchMap(({ payload }) =>
        this.apiService.postSaveContact(payload).pipe(
          map((success) => saveCalculationActions.success({ success })),
          catchError((error: AppError) => of(saveCalculationActions.error({ error }))),
        ),
      ),
    ),
  );

  constructor(private apiService: ApiService, private actions$: Actions) {}
}
